var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { postJsonWithAuthn } from "../RequestHelpers";
var EditOrderCommentModal = /** @class */ (function (_super) {
    __extends(EditOrderCommentModal, _super);
    function EditOrderCommentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCommentChange = function (event) {
            var val = event.currentTarget.value;
            _this.setState({
                msg: val
            });
        };
        _this.submitComment = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/events/id/" + encodeURIComponent(_this.props.eventId) + "/edit-comment", JSON.stringify({
                    comment: _this.state.msg
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            msg: "",
                        }, _this.props.onSubmit);
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            msg: _this.props.initialComment
        };
        return _this;
    }
    EditOrderCommentModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Form.Field, null,
                React.createElement(Form.TextArea, { onChange: this.onCommentChange, value: this.state.msg })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Comment edited."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Comment could not be edited."),
            React.createElement("br", null),
            React.createElement(Button, { disabled: this.state.msg.length === 0, icon: 'comment', labelPosition: "left", label: "Edit Comment", onClick: this.submitComment, positive: true }));
    };
    return EditOrderCommentModal;
}(React.PureComponent));
export default EditOrderCommentModal;
//# sourceMappingURL=EditOrderCommentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditOrderCommentModal.js
// module id = 1259
// module chunks = 0